import React, { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { Layout } from './components/Layout';
import { SettingsProvider } from './contexts/SettingsContext';
import { ToastProvider } from './contexts/ToastContext';
import { Dashboard } from './pages/Dashboard';
import { AnalyzedPosts } from './pages/AnalyzedPosts';
import { PostDetails } from './pages/PostDetails';
import { Posts } from './pages/Posts';
import { Alerts } from './pages/Alerts';
import { Analytics } from './pages/Analytics';
import { UserNetwork } from './pages/UserNetwork';
import { RSSAppFeeds } from './pages/RSSAppFeeds';
import { SystemMonitoring } from './pages/SystemMonitoring';
import { Settings } from './pages/Settings';
import { EnhancedRelevanceDashboard } from './pages/EnhancedRelevanceDashboard';
import PreFilterMonitor from './pages/PreFilterMonitor';
import { QueueMonitoringTest } from './pages/QueueMonitoringTest';

function App() {
  // [DEBUG-TRAP] Route matching diagnostics
  const RouteDiagnostics = () => {
    const location = useLocation();
    useEffect(() => {
      console.log('[DEBUG-TRAP] Route changed:', {
        pathname: location.pathname,
        search: location.search,
        hash: location.hash,
        timestamp: new Date().toISOString()
      });
    }, [location]);
    return null;
  };
  
  return (
    <ToastProvider>
      <SettingsProvider>
        <RouteDiagnostics />
        <Layout>
          <Routes>
            {/* Dashboard */}
            <Route path="/" element={<Dashboard />} />
            
            {/* Posts & Analysis - Specific routes BEFORE catch-all */}
            <Route path="/analyzed-posts" element={<AnalyzedPosts />} />
            <Route path="/posts" element={<Posts />} />
            <Route path="/posts/:id" element={<PostDetails />} />
            <Route path="/analysis/:analysisId" element={<PostDetails />} />
            
            {/* Other pages */}
            <Route path="/alerts" element={<Alerts />} />
            <Route path="/analytics" element={<Analytics />} />
            <Route path="/network/:username?" element={<UserNetwork />} />
            <Route path="/rss-feeds" element={<RSSAppFeeds />} />
            <Route path="/monitoring" element={<SystemMonitoring />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="/enhanced-relevance" element={<EnhancedRelevanceDashboard />} />
            <Route path="/prefilter-monitor" element={<PreFilterMonitor />} />
            <Route path="/queue-test" element={<QueueMonitoringTest />} />
            
            {/* Catch-all MUST be last */}
            <Route path="*" element={<Dashboard />} />
          </Routes>
        </Layout>
      </SettingsProvider>
    </ToastProvider>
  );
}

export default App;